import React from 'react';
import { Box, Card, useTheme, makeStyles, Typography } from '@material-ui/core';
import { history } from '../../helpers';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    borderRadius: 8,
    border: `1px solid ${theme.palette.neutrals.high.medium}`,
    '&:nth-child(1)':{
      marginBottom: theme.spacing(2)
    }
  },
  cardTitle: {
    color: theme.palette.neutrals.low.main,
  },
  number: {
    color: theme.palette.neutrals.low.medium,
  },
  textSeeAll: {
    fontSize: 12,
    fontWeight: 600,
    cursor: 'pointer',
    color: theme.palette.neutrals.low.light,
    '&:hover': {
      color: theme.palette.primary.main,
      textDecoration: 'underline',
    },
  },
}));

export function IdeaPoints({ ideaTotal, walletAmmount, userId }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const theme = useTheme();

  function handleSeeAllIdeas() {
    history.push('/my-ideas');
  }
  function handleSeeAllPoints() {
    history.push(`/wallet/${userId}`);
  }
  return (
    <Box padding="16px 0">
      <Card className={classes.row} elevation={0}>
        <Box display="flex" alignItems="center">
          <EmojiObjectsIcon color="primary" style={{ marginRight: 6 }} />
          <Typography variant="subtitle2" className={classes.cardTitle}>
            {t('ideias').toLowerCase()}
          </Typography>
        </Box>
        <Typography variant="subtitle1" className={classes.number}>
          {ideaTotal}
        </Typography>
        <Typography className={classes.textSeeAll} onClick={handleSeeAllIdeas}>
          {t('ver_todas')}
        </Typography>
      </Card>

      <Card className={classes.row} elevation={0}>
        <Box display="flex" alignItems="center">
          <AccountBalanceWalletIcon style={{ color: theme.palette.auxiliary.cyan.main, marginRight: 8 }} />
          <Typography variant="subtitle2" className={classes.cardTitle}>
            {t('pontos').toLowerCase()}
          </Typography>
        </Box>
        {walletAmmount 
          ? <Typography variant="subtitle1" className={classes.number}>{parseInt(walletAmmount)}</Typography>
          : <Typography variant="subtitle1" className={classes.number}>0</Typography>
        }
        <Typography variant="caption" className={classes.textSeeAll} onClick={handleSeeAllPoints}>
            {t('ver_todos')}
        </Typography>
      </Card>
    </Box>
  );
}

